module.exports = __webpack_public_path__ + "static/img/jxf.d4e412fd.png";